module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[115]602.a74104c.woff2";